import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { savingsEndpoints } from "@/features/savings/api/endpoints";
import type { SavingsSummaryDto } from "@/features/savings/api/dto";

/**
 * Agrégat des coffres ouverts de l'appelant (`GET /SavingsVaults/summary`) :
 * nombre de coffres et, par devise, solde total / part bloquée / part
 * retirable.
 */
export const useSavingsSummary = (enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.SAVINGS_SUMMARY(),
    queryFn: () =>
      fetchDataGet<SavingsSummaryDto>({
        url: savingsEndpoints.savingsVaults.summary,
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled,
  });
